module.exports = __webpack_public_path__ + "static/img/r_005.8351ff3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/r_005.jpg
// module id = /Yco
// module chunks = 1